import React, { useEffect, useRef, useState } from "react";

const SCORMPlayer = ({ url, config, allowFullScreen = true }) => {
  const iframeRef = useRef(null);
  const [loadContent, setLoadContent] = useState(false);
  const [userLMSValues, setUserLMSValues] = useState({
    "cmi.core.student_id": config.userId,
    "cmi.core.student_name": config.userName,
    "cmi.core.lesson_location": config.lessonLocation,
    "cmi.core.credit": "credit", // credit , no-credit
    "cmi.core.lesson_status": config.lessonStatus, // “passed”, “completed”, “failed”, “incomplete”, “browsed”, “not attempted”
    "cmi.core.entry": config.entry || "resume", // ab-initio , resume , ""  (Intial Session or Continue)
    "cmi.core.score.raw": config.score || "0",
    "cmi.core.score.min": config?.scoreMin || "0",
    "cmi.core.score.max": config?.scoreMax || "0",
    "cmi.core.total_time": config.totalTime || "0",
    "cmi.core.lesson_mode": "normal", // “browse”, “normal”, “review” Identifies one of three possible modes in which the SCO may be presented to the learner
    "cmi.core.exit": "", // “time-out”, “suspend”, “logout”, “”
    "cmi.core.session_time": config.sessionTime || "0", // Amount of time that the learner has spent in the current learner session for this SCO
    "cmi.suspend_data": config?.suspendData || "",
    "cmi.launch_data": config?.launchData || "",
    "cmi.student_data.max_time_allowed": config?.maxTimeAllowed || "0",
    "cmi.student_data.time_limit_action": config?.timeLimitAction || "continue, no message",
    // for SCORM 2004
    "cmi.learner_id": config.userId,
    "cmi.learner_name": config.userName,
    "cmi.location": config.lessonLocation,
    "cmi.credit": "credit",
    "cmi.completion_status": config.lessonStatus, // "completed" or "incomplete" or "not attempted" or "unknown"
    "cmi.success_status": "", // "passed" or "failed"
    "cmi.entry": config.entry || "resume",
    "cmi.score.raw": config.score || "0",
    "cmi.score.min": config?.scoreMin || "0",
    "cmi.score.max": config?.scoreMax || "0",
    "cmi.total_time": config.totalTime || "0",
    "cmi.mode": "normal",
    "cmi.exit": "",
    "cmi.session_time": config.sessionTime || "0",
    // "cmi.max_time_allowed": "",
  });

  const initializeHandler = (message) => {
    console.log("LMSInitialize :", message);
    if (config.initializeHandler) {
      config.initializeHandler();
    } else {
      return "true";
    }
  };
  const finishHandler = (message) => {
    console.log("LMSFinish :", message);
    if (config.finishHandler) {
      config.finishHandler();
    } else {
      return "true";
    }
  };
  const commitHandler = (message) => {
    console.log("LMSCommit :", message);
    if (config.commitHandler) {
      config.commitHandler();
    } else {
      return "true";
    }
  };
  const getValueHandler = (key) => {
    console.log("LMSGetValue :", key);
    if (config.getValueHandler) {
      config.getValueHandler();
    } else {
      if (Object.keys(userLMSValues).includes(key)) {
        return userLMSValues[key];
      }
      return "";
    }
  };
  const setValueHandler = async (key, value) => {
    console.log("LMSSetValue :", {
      [key]: value,
    });
    if (config.setValueHandler) {
      config.setValueHandler();
    }
    setUserLMSValues({ ...userLMSValues, [key]: value });
    return "";
  };
  const getLastErrorHandler = (message) => {
    console.log("LMSGetLastError :", message);
    if (config.getLastErrorHandler) {
      config.getLastErrorHandler();
    } else {
      return "0";
    }
  };
  const getErrorStringHandler = (message) => {
    console.log("LMSGetErrorString :", message);
    if (config.getErrorStringHandler) {
      config.getErrorStringHandler();
    } else {
      return "";
    }
  };
  const getDiagnosticHandler = (message) => {
    console.log("LMSGetDiagnostic :", message);
    if (config.getDiagnosticHandler) {
      config.getDiagnosticHandler();
    } else {
      return "";
    }
  };

  const initializePackage = async () => {
    const scormAPI = {
      // for SCORM 1.1/1.2
      LMSInitialize: initializeHandler,
      LMSFinish: finishHandler,
      LMSCommit: commitHandler,
      LMSGetValue: getValueHandler,
      LMSSetValue: setValueHandler,
      LMSGetLastError: getLastErrorHandler,
      LMSGetErrorString: getErrorStringHandler,
      LMSGetDiagnostic: getDiagnosticHandler,
      // for SCORM 2004
      Initialize: initializeHandler,
      Finish: finishHandler,
      Commit: commitHandler,
      GetValue: getValueHandler,
      SetValue: setValueHandler,
      GetLastError: getLastErrorHandler,
      GetErrorString: getErrorStringHandler,
      GetDiagnostic: getDiagnosticHandler,
    };
    window.API = scormAPI;
    window.API_1484_11 = scormAPI;
    setLoadContent(true);
  };
  useEffect(() => {
    initializePackage();
  }, []);

  return loadContent ? (
    <iframe
      ref={iframeRef}
      src={url}
      width="100%"
      height="600px"
      title="SCORM Package"
      allowFullScreen={allowFullScreen}
    />
  ) : null;
};

export default SCORMPlayer;
